// extracted by mini-css-extract-plugin
export var container = "NavigationMobileMenu-module--container--24rQJ";
export var button = "NavigationMobileMenu-module--button--4WN1h";
export var menu = "NavigationMobileMenu-module--menu--1lUKk";
export var menuOpen = "NavigationMobileMenu-module--menu--open--3k7gh";